import React, { FC } from 'react'
import { cn } from 'shared/utils'
import { Tooltip } from '@wmgtech/legato'

import { ConditionRender } from 'components'
import { KPIPopover } from '..'

import { ICompactFactsItemProps } from './CompactFactsItem.props'
import './CompactFactItem.scss'
import { getChartAttr } from 'shared/utils/chartConfig'

const CompactFactsItem: FC<ICompactFactsItemProps> = ({
  fact,
  trend,
  isOutdated,
  peakFact,
  source,
  countryCode,
  isExtended
}) => {
  return (
    <div
      className={cn('fact', {
        found: !!fact,
        stale: isOutdated,
        'fact--extended': isExtended
      })}
    >
      <div
        className={cn('fact-position', {
          up: trend === 'up',
          down: trend === 'down',
          out: isOutdated
        })}
      >
        <span
          className={cn('position', {
            empty: !fact?.position_current,
            'position--with-tooltip': fact?.position_current && isExtended
          })}
        >
          {fact?.position_current ? (
            <ConditionRender
              condition={isExtended}
              component={
                <Tooltip
                  colorType="white"
                  placement="top"
                  className="kpi-tooltip"
                  containerStyle="solid"
                  title={String(getChartAttr(source.chart)?.name)}
                  message={
                    <KPIPopover
                      hideTitle
                      source={source}
                      fact={fact}
                      reachedPeakAt={peakFact?.position_current_at}
                      countryCode={countryCode}
                    />
                  }
                >
                  <div style={{ textDecoration: 'underline' }}>{isOutdated ? 'out' : fact?.position_current}</div>
                </Tooltip>
              }
              secondComponent={<span>{isOutdated ? 'out' : fact?.position_current}</span>}
            />
          ) : (
            '--'
          )}
        </span>
      </div>
    </div>
  )
}

export default CompactFactsItem
